import { render, staticRenderFns } from "./OzLoadingText.vue?vue&type=template&id=2a7a6eb9&scoped=true&"
import script from "./OzLoadingText.vue?vue&type=script&lang=ts&"
export * from "./OzLoadingText.vue?vue&type=script&lang=ts&"
import style0 from "./OzLoadingText.vue?vue&type=style&index=0&id=2a7a6eb9&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7a6eb9",
  null
  
)

export default component.exports